import { InvoiceProductInfo } from '../AppContext';
import { IPaymentDetails } from '../generated/graphql';

export const defaultPaymentDto: IPaymentDetails = {
  id: '',
  contact_address_name: '',
  contact_address: '',
  contact_phone: '',
  contact_fax: '',
  contact_vat: '',
  bank_name: '',
  bank_affiliate: '',
  bank_address: '',
  bank_bic: '',
  bank_iban: ''
};

export const defaultProductInfo: InvoiceProductInfo = {
  product: null,
  discount: 0,
  discountPercent: null,
  vat: 0,
  total: 0,
  vatPercent: null
};
